module.exports = __webpack_public_path__ + "img/honor_img2.db52501d.png";